/**
 * 文字情報VOクラス
 */
export class TextInfoRegistModel {
  /**
   * Pコード
   */
  public pCode: string = <string>'';

  /**
   * 商品付随文字情報種別
   */
  public textKindID: string = <string>'';

  /**
   * 商品付随文字情報(明細)
   */
  public listTextInfo: Array<any> = null;

  /**
 * コンストラクタ
 * @param pcode Pコード
 * @param textkindid 商品付随文字情報種別
 * @param list 商品付随文字情報List
 */
  public constructor(pcode: string, textkindid: string, list: Array<any>) {
    // 引数をフィールドに設定
    this.pCode = pcode;
    this.textKindID = textkindid;
    this.listTextInfo = list;
  }
}
